import React from "react";

export default function Panel({ children, className = "" }) {
  return (
    <div
      className={`bg-white border border-border-default rounded-[20px] p-[26px] flex flex-col gap-[18px] ${className}`}
    >
      {children}
    </div>
  );
}
